import { request } from '@/common/services/request';

const getPayloadData = (payload) => payload.data;

const toProTableResult = (result) => ({
  data: result.data,
  success: true,
  total: result.meta?.total || 0,
});

export async function queryMembers(params) {
  const result = await request('/api/tenant/members', {
    method: 'GET',
    params,
  });
  return toProTableResult(result);
}

export async function queryInvitations(params) {
  const result = await request('/api/tenant/invitations', {
    method: 'GET',
    params,
  });
  return toProTableResult(result);
}

export async function createInvitation(payload) {
  const data = getPayloadData(payload);
  return request('/api/tenant/invitations', {
    method: 'POST',
    params: {
      organizationId: data.organizationId,
    },
    data: {
      phoneNumber: data.phoneNumber,
      role: data.role,
    },
  });
}

export async function updateMemberRole(payload) {
  const data = getPayloadData(payload);
  return request('/api/tenant/members/role', {
    method: 'PATCH',
    params: {
      organizationId: data.organizationId,
      memberId: data.memberId,
    },
    data: {
      role: data.role,
    },
  });
}

export async function removeMember(payload) {
  const data = getPayloadData(payload);
  return request('/api/tenant/members', {
    method: 'DELETE',
    params: {
      organizationId: data.organizationId,
      memberId: data.memberId,
    },
  });
}

export async function cancelInvitation(payload) {
  const data = getPayloadData(payload);
  return request('/api/tenant/invitations', {
    method: 'DELETE',
    params: {
      organizationId: data.organizationId,
      invitationId: data.invitationId,
    },
  });
}
